export default "__VITE_ASSET__mxm36ZlW__"